import { ScanPhoto } from '../ScanRoot';
import { ScanPartOptimized } from '../ScanRootOptimized';

/**
 * Canonical scan video id for a photo attachment, reading legacy `orgVideoId` when present.
 *
 * CAVEAT: for legacy photos this returns an `OrgVideo.id` under a "scan video id" name. That is
 * safe for presence/boolean checks (agent-updated, video-still), but do NOT feed the result into a
 * `ScanVideo` lookup or S3-key derivation — a legacy id will not resolve as a `ScanVideo`.
 */
export const getScanPhotoScanVideoId = (photo: ScanPhoto): string | undefined => photo.scanVideoId ?? photo.orgVideoId;

/**
 * True when a photo attachment came from VideoToScopeJob (video frame extract),
 * attributed to the user who uploaded the walkthrough video.
 */
export const isScanPhotoAgentUpdated = (photo: ScanPhoto): boolean => !!getScanPhotoScanVideoId(photo) && !!photo.addedByUserId;

/**
 * True when this scan part was touched by VideoToScopeJob — flagged with
 * `agentAdded` or carrying an agent-attributed photo in its rollup (`optimized.allPhotos`).
 *
 * For descendants, compose at the call site (same pattern as scopingLib), e.g.
 * `group.tasks?.some(isScanPartAgentUpdated)`.
 */
export const isScanPartAgentUpdated = (scanPart: ScanPartOptimized | undefined | null): boolean =>
  scanPart != null && (
    scanPart.agentUpdatedAt != null
    || (scanPart.optimized.allPhotos?.some(isScanPhotoAgentUpdated) ?? false)
  );
